import styled, { css } from 'styled-components';

interface CardPARAMS {
  titulo_ind: string;
}

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4.5rem 1.5rem 5rem 5.5rem; // 4.42rem 1.5rem 5rem 5.5rem;

  // 767px
  @media (max-width: 47.9375rem) {
    margin-left: 0;
		padding: 4.3rem 0.5rem 5rem;
  }
`;

export const CardList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  list-style: none;
  transition: 0.2s;
	width: 90%;

	// 970px
  @media (max-width: 60.625rem) {
    grid-template-columns: repeat(2, 1fr);
		width: 100%;
  };
	// 585px
  @media (max-width: 36.5625rem) {
    grid-template-columns: repeat(1, 1fr);
		grid-gap: 10px;
  };
`;

export const Card = styled.div<CardPARAMS>`
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 5px;

  hr {
    background-color: #cfd8dc;
    border: none;
    width: 100%;
    height: 1px;
    margin: 10px 0 10px 0;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .card-header-left {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      margin: 0 10px 0 5px;
      width: 100%;
      // border: 2px solid red;

      .card-header-left-icon {
        display: flex;
        align-items: center;

        h2 {
          font-size: 18px;
          font-weight: 500;
          color: #546e7a;
          padding-right: 5px;
          // text-align: right;
        }
      }

      img {
        // font-size: 36px;
        margin-right: 10px;
      }

      ${props =>
        props.titulo_ind === 'P'
          ? css`
              svg {
                color: var(--azul-razio);
              }
            `
          : css`
              svg {
                color: var(--red-razio);
              }
            `}
    }
    .card-header-right {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      width: 100%;
      white-space: pre;
      // border: 2px solid orange;

      h3 {
        font-weight: 500;
        color: #455a64;
        text-align: right;
      }
      h2 {
        font-weight: 500;
        color: #546e7a;
        text-align: right;
      }
    }
  }

  .card-rodape {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    span {
      font-size: 0.8rem;
      font-weight: 600;
      color: #607d8b;
      word-wrap: normal; // break-word;
    }

    .card-rodape-left {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      white-space: pre;
      margin-right: 20px;
      // border: 2px solid blue;

      span {
      }
    }

    .card-rodape-right {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      // border: 2px solid red;

      span {
        text-align: end;
      }
    }
  }

	// 970px
  @media (max-width: 60.625rem) {
    width: 100%;
  };
	// 585px
  @media (max-width: 36.5625rem) {
    width: 100%;
  };
`;
